// extracted by mini-css-extract-plugin
module.exports = {"bookBanner":"bookBanner_bookBanner__4FGaV","bookBannerContainer":"bookBanner_bookBannerContainer__UC6Vc","formElement":"bookBanner_formElement__xJg5u"};